<label class="brn-checkbox-wrapper" (click)="switch()">
  <span class="brn-checkbox__checkmark" [ngClass]="{ active: value }">
    <i class="material-icons"> check </i>
  </span>
  <ng-content></ng-content>
</label>
<div class="brn-checkbox-wrapper"></div>
